<template>
  <div :class="scope.clsPrefix">
    <div class="list-container">
      <div class="search-area">
        <el-input size="small" placeholder="搜索事项标题..." v-model="searchText" class="search-input"></el-input>
        <el-select size="small" v-model="filterType" placeholder="优先级" class="filter-select">
          <el-option label="全部" value=""></el-option>
          <el-option label="高优先级" value="highLevel"></el-option>
          <el-option label="中优先级" value="mediumLevel"></el-option>
          <el-option label="低优先级" value="lowLevel"></el-option>
          <!-- <el-option label="供应链决策" value="supply"></el-option> -->
        </el-select>
        <!-- <el-select size="small" v-model="filterCategory" placeholder="数字人" class="filter-select">
          <el-option label="全部" value=""></el-option>
          <el-option label="财务数字人" value="strategy"></el-option>
          <el-option label="ceo数字人" value="resource"></el-option>
          <el-option label="供应链数字人" value="risk"></el-option>
        </el-select> -->
        <el-button size="small" type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
      </div>
      <div class="summary-text"><span>待决策事项</span>（共 {{ total }} 条 ）</div>
      <div v-if="decisionList.length > 0" class="decision-list">
        <div v-for="(item, index) in decisionList" :key="index" class="decision-item" @click="handleDecisionClick(item)">
          <div class="decision-main">
            <div class="decision-header">
            <div class="decision-title">{{ item.title }}</div>
          </div>
          <div class="decision-desc">{{ item.desc }}</div>
          <span class="decision-meta">{{ item.owner }} | {{ item.time.substring(0, 10) }}</span>
          </div>

          <div class="decision-footer">
             <span class="priority-tag" :class="item.priorityClass">{{ item.priority }}</span>
            <div class="action-buttons">
              <span class="action-btn primary" @click.stop="handleSmartAnalysis(item)">智能分析</span>
              <!-- v-if="item.status === '待决策'"  -->
              <!-- <span v-else-if="item.status === '已完成'" class="action-btn secondary" @click.stop="handleViewResult(item)">已决策</span> -->
            </div>
          </div>
        </div>
      </div>
      <div v-else class="empty-state">暂无数据</div>
    </div>
  </div>
</template>

<script>
import { getDecisionListApi } from '@/api/agentAuth'
export default {
  name: 'DecisionList',
  props: {
    reviewerAgentId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      scope: {
        clsPrefix: 'rvc-cosmoplat-workspace-decision-list'
      },
      searchText: '',
      filterType: '',
      filterCategory: '',
      decisionList: [],
      total: 0,
      pendingCount: 0
    }
  },
  created() {
    this.fetchDecisionList()
  },
  methods: {
    async fetchDecisionList() {
      const params = {}
      if (this.reviewerAgentId) params.reviewerAgentId = this.reviewerAgentId
      if (this.searchText) params.title = this.searchText
      if (this.filterType) {
        const typeMap = { highLevel: 'HIGH', mediumLevel: 'MEDIUM', lowLevel: 'LOW' }
        params.priority = typeMap[this.filterType]
      }
      if (this.filterCategory) {
        const categoryMap = { strategy: 3, resource: 1, risk: 2 }
        params.reviewerAgentId = categoryMap[this.filterCategory]
      }
      try {
        const res = await getDecisionListApi(params)
        if (res && res.data && res.data.length > 0) {
          this.decisionList = this.transformData(res.data)
          this.total = res.data.length
          this.pendingCount = res.data.filter(item => item.status === 'PENDING').length
        } else {
          this.decisionList = []
          this.total = 0
          this.pendingCount = 0
        }
      } catch (error) {
        console.error('获取待决策事项失败:', error)
        this.decisionList = []
        this.total = 0
        this.pendingCount = 0
      }
    },
    transformData(data) {
      return data.map(item => ({
        id: item.id,
        title: item.title,
        desc: item.description,
        description: item.description || '',
        owner: item.reviewerAgentName || item.reviewer || 'CEO数字人',
        time: item.updateTime || item.createTime || '',
        priority: this.getPriorityText(item.priority),
        priorityClass: this.getPriorityClass(item.priority),
        status: item.status === 'PENDING' ? '待决策' : '已完成'
      }))
    },
    getPriorityText(priority) {
      const map = { HIGH: '高优先级', MEDIUM: '中优先级', LOW: '低优先级' }
      return map[priority] || '待决策'
    },
    getPriorityClass(priority) {
      const map = { HIGH: 'priority-pending', MEDIUM: 'priority-medium', LOW: 'priority-low' }
      return map[priority] || 'priority-pending'
    },
    handleSearch() {
      this.fetchDecisionList()
    },
    handleDecisionClick(item) {
      this.$emit('open-detail', item)
    },
    handleSmartAnalysis(item) {
      this.$emit('smart-analysis', {
        type: 'pendingDecision',
        content: item.desc || '分析待决策事项'
      })
    },
    handleViewResult(item) {
      this.$emit('view-result', item)
    }
  }
}
</script>

<style lang="scss" scoped>
$class-prefix: "rvc-cosmoplat-workspace-decision-list";
.#{$class-prefix} {
  // padding: 24px;
  // background: #fff;
  // border-radius: 8px;
  min-height: 500px;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.list-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.search-area {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 40px;
}
.search-input {
  // width: 300px;
  flex: 1;
}
.filter-select {
  width: 140px;
}
.summary-text {
  font-size: 14px;
  color: #595959;
  margin-bottom: 16px;
  font-family: PingFangSC-Regular;
}
.summary-text span {
  font-weight: 600;
  color: #000;
}
.decision-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #fff transparent;
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #fff;
    border-radius: 2px;
  }
}
.decision-item {
  padding: 16px 24px;
  background: #FAFBFC;
  border-radius: 8px;
  // border: 1px solid #E8ECF0;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  // &:hover {
  //   border-color: #4A5FF3;
  //   background: #F5F7FF;
  // }
}
.decision-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}
.decision-title {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  font-family: PingFangSC-Medium;
}
.priority-tag {
  padding: 6px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  // line-height: 24px;
  // text-align: center;
  &.priority-pending {
    background: #FFEBEE;
    color: #F44336;
  }
  &.priority-done {
    background: #E8F5E9;
    color: #4CAF50;
  }
  &.priority-medium {
    background: #FFF8E1;
    color: #FF9800;
  }
  &.priority-low {
    background: #E3F2FD;
    color: #2196F3;
  }
}
.decision-desc {
  font-size: 12px;
  color: #666;
  margin-bottom: 16px;
  font-family: PingFangSC-Regular;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.decision-main {
  flex: 1;
}
.decision-footer {
  display: flex;
  align-items: center;
  gap: 24px;
  justify-content: space-between;
}
.decision-meta {
  font-size: 12px;
  color: #999;
  font-family: PingFangSC-Regular;
}
.action-buttons {
  display: flex;
  gap: 8px;
}
.action-btn {
  padding: 6px 16px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  font-family: PingFangSC-Regular;
  transition: all 0.2s;
  height: 24px;
  background-image: linear-gradient(270deg, #4A5FF3 0%, #4E86FF 100%);
  border-radius: 12px;
  // line-height: 24px;
  // text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  &.primary {
    background: #4A5FF3;
    color: #fff;
    &:hover {
      background: #3d52d5;
    }
  }
  &.secondary {
    background: #E8ECF0;
    color: #666;
    &:hover {
      background: #d9dde3;
    }
  }
}
.empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
  color: #999;
  font-size: 14px;
}
</style>
